const leadsMixins = {
    methods: {
      checkTerms(model, form) {
        let termsAccepted = false
        // eslint-disable-next-line max-len
        if (model.TermsMandatory && model.AdditionalTermsMandatory) termsAccepted = form.termsAccepted && form.additionalTermsAccepted
        if (model.TermsMandatory && !model.AdditionalTermsMandatory) termsAccepted = form.termsAccepted
        if (!model.TermsMandatory && model.AdditionalTermsMandatory) termsAccepted = form.additionalTermsAccepted
        return termsAccepted
      },
    },
  }
  
  export default leadsMixins
